import { BehaviorSubject, forkJoin, map, Observable, tap } from "rxjs";
import { inject, ProviderToken } from "@angular/core";
import { ResolveFn } from "@angular/router";

export abstract class DataStore {

    protected abstract store: Record<string, BehaviorSubject<any>>;

    protected init<T>(key: string, fetchFn: () => Observable<T>): Observable<T> {
        return fetchFn().pipe(tap(data => this.store[key].next(data)));
    }

    protected select<T>(key: string): Observable<T> {
        return this.store[key].asObservable();
    }

    static on<TStore extends DataStore, T>(
        this: ProviderToken<TStore>,
        getter: (store: TStore) => Observable<T>
    ): ResolveFn<Observable<T>> {
        return () => getter(inject(this as ProviderToken<TStore>));
    }

    preload(...observables: Observable<any>[]): Observable<void> {
        return forkJoin(observables).pipe(map(() => void 0));
    }

    emptyStore(): void {
        Object.values(this.store).forEach(subject => subject.next(undefined));
    }
}